import React from "react";

import { useIntl } from "react-intl";

import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";

import ColorKey from "./ColorKey";

interface Props {
  entityType: EntityTypesSupportedByMapsPage;
}

const PinColorKey: React.FC<Props> = ({ entityType }) => {
  const intl = useIntl();
  return (
    <ColorKey>
      {intl.formatMessage(
        {
          id: "map.layer.colorKey.legend.pinColor.description",
          defaultMessage:
            "Each pin will reflect the color {entityType, select, deals {of the stage it is currently in. To modify the stage, edit the Deal.} other {assigned at the individual record level. You can modify a pin’s color by editing the {entityType, select, accounts {Company} contacts {Person} other {Record}}.}}",
          description: "Description of the Pin Color legend",
        },
        { entityType }
      )}
    </ColorKey>
  );
};

export default PinColorKey;
